<div class="provider-container flex flex-col min-h-screen w-full h-full">
    @if (isLoading() === false) {
    @if (provider(); as p) {
    <app-title-section [title]="p.firstName + ' ' + p.lastName"></app-title-section>

    <div class="details flex flex-col w-full h-full gap-y-4">
        <div class="card header-card flex justify-between items-center">
            <div class="flex gap-x-2">
                <p-avatar [label]="getLabelForAvatar()" class="mr-2" size="large" shape="circle" />
                @if (p.firstName && p.lastName && p.companyName) {
                    <div class="name flex flex-col">
                        <p class="font-extrabold text-lg">{{ p.firstName }} {{ p.lastName }}</p>
                        <p class="text-sm text-gray-600">{{ p.companyName }}</p>
                    </div>
                } @else {
                    <p class="font-extrabold text-lg m-auto">Profil incomplet</p>
                }
            </div>
            @if (p.verified) {
                <p-chip class="verified-chip">
                    <app-icon-svg 
                        class="search-icon"
                        width="16" 
                        height="16" 
                        iconName="success-chip" 
                        color="#347A79"
                    ></app-icon-svg>
                    <span class="text-sm">Vérifié</span>
                </p-chip>
            } @else {
                <p-chip class="not-verified-chip">
                    <app-icon-svg 
                        class="search-icon"
                        width="16" 
                        height="16" 
                        iconName="error-chip" 
                        color="#de8700"
                    ></app-icon-svg>
                    <span class="text-sm">Non Vérifié</span>
                </p-chip>
            }
        </div>

        <div class="grids-wrapper">
            <div class="grid-row">
                <div class="card flex flex-col gap-y-4">
                    <h2>Informations de contact</h2>
                    <div class="info flex flex-col gap-y-2">
                        <p class="text-sm uppercase font-semibold">Email</p>
                        <div class="flex items-center gap-x-2">
                            <app-icon-svg 
                                width="16" 
                                height="16" 
                                iconName="user" 
                                color="#57636c"
                            ></app-icon-svg>
                            <span class="text-sm">{{ p.email }}</span>
                        </div>
                    </div>
                    <div class="info flex flex-col gap-y-2">
                        <p class="text-sm uppercase font-semibold">Téléphone</p>
                        <div class="flex items-center gap-x-2">
                            <app-icon-svg 
                                width="16" 
                                height="16" 
                                iconName="phone" 
                                color="#57636c"
                            ></app-icon-svg>
                            @if (p.phoneNumber) {
                                <span class="text-sm">{{ p.phoneNumber }}</span>
                            } @else {
                                <span class="text-sm">Non renseigné</span>
                            }
                        </div>
                    </div>
                    <div class="info flex flex-col gap-y-2">
                        <p class="text-sm uppercase font-semibold">Adresse</p>
                        <div class="flex items-center gap-x-2">
                            <app-icon-svg 
                                width="16" 
                                height="16" 
                                iconName="location" 
                                color="#57636c"
                            ></app-icon-svg>
                            @if (p.address) {
                                <span class="text-sm">{{ p.address }}</span>
                            } @else {
                                <span class="text-sm">Non renseigné</span>
                            }
                        </div>
                    </div>
                    <div class="info flex flex-col gap-y-2">
                        <p class="text-sm uppercase font-semibold">Ville</p>
                        <div class="flex items-center gap-x-2">
                            <app-icon-svg 
                                width="16" 
                                height="16" 
                                iconName="location" 
                                color="#57636c"
                            ></app-icon-svg>
                            @if (p.city) {
                                <span class="text-sm">{{ p.city }}</span>
                            } @else {
                                <span class="text-sm">Non renseigné</span>
                            }
                        </div>
                    </div>
                </div>
                <div class="card flex flex-col gap-y-4">
                    <h2>Informations  de l'entreprise</h2>
                    <div class="info flex flex-col gap-y-2">
                        <p class="text-sm uppercase font-semibold">Raison sociale</p>
                        <div class="flex items-center gap-x-2">
                            <app-icon-svg 
                                width="16" 
                                height="16" 
                                iconName="cgu-cgv" 
                                color="#57636c"
                            ></app-icon-svg>
                            @if (p.companyName) {
                                <span class="text-sm">{{ p.companyName }}</span>
                            } @else {
                                <span class="text-sm">Non renseigné</span>
                            }
                        </div>
                    </div>
                    <div class="info flex flex-col gap-y-2">
                        <p class="text-sm uppercase font-semibold">Siret</p>
                        <div class="flex items-center gap-x-2">
                            <app-icon-svg 
                                width="16" 
                                height="16" 
                                iconName="document" 
                                color="#57636c"
                            ></app-icon-svg>
                            @if (p.siretNumber) {
                                <span class="text-sm">{{ p.siretNumber }}</span>
                            } @else {
                                <span class="text-sm">Non renseigné</span>
                            }
                        </div>
                    </div>
                    <div class="info flex flex-col gap-y-2">
                        <p class="text-sm uppercase font-semibold">Date d'inscription</p>
                        <div class="flex items-center gap-x-2">
                            <app-icon-svg 
                                width="16" 
                                height="16" 
                                iconName="document" 
                                color="#57636c"
                            ></app-icon-svg>
                            <span class="text-sm">{{ p.createdAt | date: 'dd/MM/yyyy' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-row">
                <div class="card flex flex-col gap-y-4">
                    <h2>Statuts</h2>
                    <div class="flex flex-col">
                        <div class="flex items-center justify-between">
                            <span class="text-sm">Stripe Connect</span>
                            <div class="status flex items-center gap-x-2">
                                <app-icon-svg 
                                    width="16" 
                                    height="16" 
                                    [iconName]="p.stripeConnectedAccountId ? 'success-chip' : 'error-chip'" 
                                    [color]="p.stripeConnectedAccountId ? '#49a3a3' : '#e0074c'"
                                >
                                </app-icon-svg>
                                <p [class.text-success]="p.stripeConnectedAccountId" [class.text-danger]="!p.stripeConnectedAccountId">
                                    {{ p.stripeConnectedAccountId ? 'Oui' : 'Non' }}
                                </p>
                            </div>
                        </div>
                        <p-divider />
                        <div class="flex items-center justify-between">
                            <span class="text-sm">Onboarding terminé</span>
                            <div class="status flex items-center gap-x-2">
                                <app-icon-svg 
                                    width="16" 
                                    height="16" 
                                    [iconName]="p.onboardingCompletedAt ? 'success-chip' : 'error-chip'" 
                                    [color]="p.onboardingCompletedAt ? '#49a3a3' : '#e0074c'"
                                >
                                </app-icon-svg>
                                <p [class.text-success]="p.onboardingCompletedAt" [class.text-danger]="!p.onboardingCompletedAt">
                                    {{ p.onboardingCompletedAt ? 'Oui' : 'Non' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card flex flex-col gap-y-4">
                    <h2>Actions</h2>
                    <div class="flex flex-col gap-y-4">
                        <p-button
                        class="confirm-btn"
                        label="Créer compte Stripe + Onboarding" 
                        [loading]="isSubmitOnboarding()"
                        (click)="createStripeConnectAccount()"
                        [disabled]="isSubmitOnboarding() || p.verified"
                        fluid />
                        <p-button
                        class="confirm-btn"
                        label="Fin du rendez-vous avec le prestataire" 
                        [loading]="isSubmitAppointment()"
                        (click)="validateAppointment()"
                        [disabled]="isSubmitAppointment() || p.rdvCompletedAt || isAppointmentCompleted()"
                        fluid />
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    } @else {
    <!-- Loading -->
    <div class="loading-spinner flex justify-center">
        <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" class="progress-spinner" />
    </div>
    }
</div>